import React from 'react';
import { CTAButton } from './CTAButton';
import { FloatingMockup } from './FloatingMockup';
import { PHOTOS } from '../data/photos';

/**
 * HERO OPTIMIZADO PARA MOBILE.
 * El mockup se limita por altura de viewport (max-h) además de por ancho, así
 * el precio y el CTA siempre entran en el primer pantallazo sin recortar ni
 * deformar la imagen. En desktop vuelve a la composición texto / mockup.
 */
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-119" data-mp="128yzydv6bxz6">
      {/* Fondo fotográfico muy suave: da calidez artesanal sin restarle
          protagonismo al mockup ni afectar la legibilidad del copy. */}
      <div className="pointer-events-none absolute inset-0" aria-hidden data-id="element-120" data-mp="s9ghy2ytqm9r">
        <img src={PHOTOS.heroBackdrop} alt="" decoding="async" className="h-full w-full object-cover opacity-30" data-id="element-121" data-mp="nbexpepnwgwp" />
        <div className="absolute inset-0 bg-cream/80" data-id="element-122" data-mp="382p4rap7j9k3" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-cream" data-id="element-123" data-mp="3814aznapvuna" />
      </div>
      <div className="pointer-events-none absolute -top-32 left-1/2 h-72 w-[34rem] -translate-x-1/2 rounded-full bg-sand blur-3xl" aria-hidden data-id="element-124" data-mp="3j6fvvj9ob1ao" />

      <div className="relative mx-auto max-w-md px-5 pb-6 pt-3 text-center sm:max-w-lg sm:pb-10 sm:pt-7 lg:max-w-5xl lg:pb-14 lg:pt-12 lg:text-left" data-id="element-125" data-mp="399jo5frlmj76">
        <div className="lg:grid lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:items-center lg:gap-12" data-id="element-126" data-mp="30i19j9aawbg7">
          <div className="animate-hero-copy" data-id="element-127" data-mp="358hoixtrs54o">
            <p className="font-display text-[0.56rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.66rem]" data-id="element-128" data-mp="35aat87ktofa1">
              El manual más completo y actualizado
            </p>

            <h1 className="mt-1.5 font-display text-[1.75rem] font-extrabold uppercase leading-[0.94] tracking-tight text-charcoal sm:text-[2.3rem] lg:text-[2.9rem]" data-id="element-129" data-mp="2vjg5szvub9n0">
              200 Fórmulas
              <span className="mt-0.5 block font-accent text-[1.15rem] normal-case tracking-normal text-gold-deep sm:text-[1.5rem] lg:text-[1.95rem]" data-id="element-130" data-mp="2ljh15e2jk3ff">
                de Jabones Artesanales de Glicerina
              </span>
            </h1>

            <p className="mx-auto mt-2 max-w-[30ch] font-sans text-[0.86rem] font-medium leading-snug text-taupe sm:text-[0.95rem] lg:mx-0 lg:max-w-[34ch]" data-id="element-131" data-mp="ic85x8ls7uuo">
              Fabricá jabones hermosos y convertí tu hobby en{' '}
              <strong className="font-bold text-charcoal" data-id="element-132" data-mp="1b1fez1iv42u6">un ingreso desde casa.</strong>
            </p>

            {/* MOCKUP — en mobile aparece acá, entre el beneficio y la oferta. */}
            <div className="relative my-3 lg:hidden" data-id="element-133" data-mp="112g5xhu6q56n">
              <FloatingMockup alt="Colección 200 Fórmulas de Jabones Artesanales de Glicerina: 4 tomos digitales y 5 libros extra de regalo" sizes="(max-width: 640px) 100vw, 480px" priority className="max-w-[30rem]" data-id="element-134" data-mp="110wovp0pfq3t" />
            </div>

            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1.5 lg:mt-5 lg:justify-start" data-id="element-135" data-mp="3htg5fwqahzd2">
              <span className="font-display text-[0.72rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.8rem]" data-id="element-136" data-mp="21awe8b624vhh">
                200 fórmulas
              </span>
              <span className="h-1 w-1 rounded-full bg-gold" aria-hidden data-id="element-137" data-mp="267wjijv31u7j" />
              <span className="font-display text-[0.72rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.8rem]" data-id="element-138" data-mp="2b2aiew8yejgy">
                4 tomos
              </span>
              <span className="rounded-full bg-gold px-2.5 py-1 font-display text-[0.68rem] font-bold uppercase tracking-[0.06em] text-white sm:text-[0.74rem]" data-id="element-139" data-mp="2ky40sw9ct76n">
                5 libros extra gratis
              </span>
            </div>

            <div className="mt-4 flex justify-center lg:justify-start" data-id="element-140" data-mp="2tysf7s2nt9k2">
              {/* Lleva por scroll a la tarjeta de oferta: el precio se revela recién ahí. */}
              <CTAButton href="#comprar" className="w-full max-w-[24rem] px-4" data-id="element-141" data-mp="zmlthzc53adi" />
            </div>
          </div>

          {/* MOCKUP — versión desktop, a la derecha del copy. */}
          <div className="hidden lg:block" data-id="element-142" data-mp="3vi714skacoxd">
            <FloatingMockup alt="" sizes="480px" priority parallax className="max-w-[30rem]" data-id="element-143" data-mp="3vhfei78o21j8" />
          </div>
        </div>
      </div>
    </section>;
}